export { default as UIUtils } from './ui';
export * from './mobile';

export const getUrlParam = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};
